import { useMutation } from 'react-query'
import { endpoints } from '@app/api/config'
import {
  ApiErrorResponse,
  ApiTestFormulaRequestBody,
  ApiTestFormulaResponse,
} from 'BackendApi'
import { apiAuthClient } from '@app/services/apiAuthClient'
import { AxiosResponse } from 'axios'

const postTestFormula = async (
  bridgeId: string,
  postBody: ApiTestFormulaRequestBody
): Promise<ApiTestFormulaResponse> => {
  const apiResponse: AxiosResponse<ApiTestFormulaResponse> =
    await apiAuthClient.post(endpoints.testFormula({ bridgeId }), postBody)

  return apiResponse.data
}

export const useTestFormula = (bridgeId?: string) =>
  useMutation<
    ApiTestFormulaResponse,
    ApiErrorResponse,
    ApiTestFormulaRequestBody
  >((postBody) => postTestFormula(bridgeId!, postBody))
